import { render, staticRenderFns } from "./ArtefactView.vue?vue&type=template&id=6f034627&scoped=true&"
import script from "./ArtefactView.vue?vue&type=script&lang=js&"
export * from "./ArtefactView.vue?vue&type=script&lang=js&"
import style0 from "./ArtefactView.vue?vue&type=style&index=0&id=6f034627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f034627",
  null
  
)

export default component.exports